import {createElement} from 'react'
import {addMaybeClassName} from '@freckle/educator-entities/ts/common/helpers/classnames'
import {innerHTMLText} from '@freckle/educator-entities/ts/common/models/html-text'
import type {HeadingProps} from '@freckle/educator-materials/ts/components/typography/heading-props'
import {h1} from './typography.module.scss'

type Props = HeadingProps

export function H1(props: Props) {
  const {children, className, dataTest = 'page-title', id} = props
  const newClassName = addMaybeClassName(h1, className)
  const tagToUse = props.as ?? 'h1'
  const node = createElement(
    tagToUse,
    {
      className: newClassName,
      'data-test': dataTest,
      id,
      ...(props.innerHTMLText !== undefined ? innerHTMLText(props.innerHTMLText) : {}),
    },
    children,
  )

  return node
}
